module.exports = __webpack_public_path__ + "img/login-clementeballen.ba461e59.svg";